import { useContext, useEffect, useMemo, useState } from "react"
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, timeStringToDate } from "../../../utils/Helper";
import { callautopopulate } from "../../../services/callautopop";

export const useCalendarConfig = ({ dayTypeOption, getHolidayCalender }) => {

    const { showSuccess, showInfo } = useContext(ToastContext);
    const [publishData, setPublishData] = useState({ year: 0, unit: {}, config: {} });
    const [generateCalendarData, setGenerateCalendarData] = useState({
        display_name: "",
        weekly_off: { count: 1, data: [], day_type_id: 0 },
        holiday: { count: 1, data: [], day_type_id: 0 },
        optional_holiday: { count: 1, data: [], day_type_id: 0 },
        configuration_data: {},
        shift_start: "",
        shift_end: ""
    });
    const [dayOpts, setDayOpts] = useState({ 0: [{ weekday: "Sunday", day_idx: 0 }, { weekday: "Saturday", day_idx: 6 }, { weekday: "Friday", day_idx: 5 }, { weekday: "Thursday", day_idx: 4 }, { weekday: "Wednesday", day_idx: 3 }, { weekday: "Tuesday", day_idx: 2 }, { weekday: "Monday", day_idx: 1 }] });
    const [configList, setConfigList] = useState([]);
    const [callAutopop, setCallAutopop] = useState(false);
    const [loader, setLoader] = useState({ list: true, fields: false, btn: false, publish_btn: false });
    const [showConfirmation, setShowConfirmation] = useState({ visible: false, config: {} });

    useEffect(() => {
        sessionStorage.removeItem("day_calendar_config");
        callautopopulate("day_calendar_config")?.then(res => {
            const configs = _.uniq(res?.day_calendar_config, "configuration_id");
            setConfigList(configs);
            setLoader((prev) => ({ ...prev, list: false }));
        }).catch(err => {
            setLoader((prev) => ({ ...prev, list: false }));
        })
    }, [callAutopop])

    useEffect(() => {
        setGenerateCalendarData((prev) => ({
            ...prev,
            weekly_off: { ...prev?.weekly_off, day_type_id: _.findWhere(dayTypeOption, { day_type_key: "weekly_off" })?.day_type_id || 0 },
            holiday: { ...prev?.holiday, day_type_id: _.findWhere(dayTypeOption, { day_type_key: "holiday" })?.day_type_id || 0 },
            optional_holiday: { ...prev?.optional_holiday, day_type_id: _.findWhere(dayTypeOption, { day_type_key: "optional_holiday" })?.day_type_id || 0 }
        }));
    }, [dayTypeOption])

    const handleDaySelection = (key, val, index) => {
        let weeklyOffSelectedData = [...generateCalendarData?.weekly_off?.data];
        if (key === "day" || key === "is_all") {
            weeklyOffSelectedData[index] = { ...weeklyOffSelectedData[index], [key]: val };
            if (key === "is_all") {
                weeklyOffSelectedData[index]["selected_each_day"] = [];
            }
        } else if (key === "selected_each_day") {
            weeklyOffSelectedData[index]["is_all"] = false;
            if (!weeklyOffSelectedData[index]?.[key]) {
                weeklyOffSelectedData[index][key] = [val];
            } else if (weeklyOffSelectedData[index][key]?.includes(val)) {
                weeklyOffSelectedData[index][key] = _.filter(weeklyOffSelectedData[index][key], item => item !== val)
            } else {
                weeklyOffSelectedData[index][key].push(val);
            }
        }
        setGenerateCalendarData((prev) => ({ ...prev, weekly_off: { ...prev?.weekly_off, data: [...weeklyOffSelectedData] } }));
    }

    const handleDateSelection = (key, key2, val, index) => {
        let selectedData = [...generateCalendarData?.[key]?.data];
        let value = val;
        if (key2 === "date") {
            const savedDates = _.pluck(selectedData, "date");
            if (!_.isEmpty(_.filter(savedDates, item => _.isEqual(item, val)))) {
                showInfo("info", "This date is already selected");
                value = "";
            }
        }
        selectedData[index] = { ...selectedData[index], [key2]: value };
        setGenerateCalendarData((prev) => ({ ...prev, [key]: { ...prev?.[key], data: [...selectedData] } }));
    }

    const handleAddMore = (key) => {
        const previousData = generateCalendarData?.[key]?.data?.[generateCalendarData?.[key]?.count - 1]
        if (key === "weekly_off" && !_.isEmpty(previousData) && previousData?.is_all !== undefined && ((!previousData?.is_all && !_.isEmpty(previousData?.selected_each_day)) || previousData?.is_all)) {
            setGenerateCalendarData((prev) => ({ ...prev, [key]: { ...prev?.[key], count: generateCalendarData?.[key]?.count + 1 } }));

            // Remove the selected day from option
            const filterOpts = _.filter(dayOpts?.[0], (item) => !_.pluck(generateCalendarData?.[key]?.data, "day")?.includes(item));
            setDayOpts((prev) => ({ ...prev, [generateCalendarData?.[key]?.count]: filterOpts }));

        } else if ((key === "holiday" || key === "optional_holiday") && previousData?.date && previousData?.title) {
            setGenerateCalendarData((prev) => ({ ...prev, [key]: { ...prev?.[key], count: generateCalendarData?.[key]?.count + 1 } }));
        } else {
            showInfo("Info", "Please fill all previous fields before adding new!")
        }
    }

    const handleReset = () => {
        setPublishData((prev) => ({ ...prev, year: 0, unit: {}, config: {} }))
        setGenerateCalendarData((prev) => ({
            ...prev,
            display_name: "",
            weekly_off: { count: 1, data: [], day_type_id: prev?.weekly_off?.day_type_id },
            holiday: { count: 1, data: [], day_type_id: prev?.holiday?.day_type_id },
            optional_holiday: { count: 1, data: [], day_type_id: prev?.optional_holiday?.day_type_id },
            configuration_data: {},
            shift_start: "",
            shift_end: ""
        }));
        setDayOpts({ 0: [{ weekday: "Sunday", day_idx: 0 }, { weekday: "Saturday", day_idx: 6 }, { weekday: "Friday", day_idx: 5 }, { weekday: "Thursday", day_idx: 4 }, { weekday: "Wednesday", day_idx: 3 }, { weekday: "Tuesday", day_idx: 2 }, { weekday: "Monday", day_idx: 1 }] });
    }

    const getDates = (day, dayArr) => {
        const year = new Date()?.getFullYear();
        let datesArray = [];
        for (let i = 0; i < 12; i++) {
            let count = 0;
            const lastDate = new Date(year, i + 1, 0).getDate();
            for (let j = 1; j <= lastDate; j++) {
                const wholeDate = new Date(year, i, j)
                if (wholeDate?.getDay() === day?.day_idx) {
                    count++;
                    if (dayArr?.includes(count - 1)) {
                        datesArray.push(wholeDate);
                    }
                }
            }
        }
        return datesArray;
    }

    const getSavedConfiguration = async (config) => {
        try {
            const payload = {
                configuration_id: config?.configuration_id || 0
            }
            setLoader((prev) => ({ ...prev, fields: true }));
            const res = await services.getInvokeRemote("POST", Urls("GETDAYCALENDARCONFIG"), payload);
            if (res) {
                const data = res?.body?.data;

                // set weekly off data
                let weekly = [];
                const weekly_off_data = _.uniq(_.filter(data?.weekly_off_data, item => item?.description), "day_name");
                weekly_off_data?.forEach((item) => {
                    let obj = {
                        day: _.findWhere(dayOpts?.[0], { weekday: item?.day_name }) || {},
                        selected_each_day: item?.description?.split(",")?.length === 5 ? [] : item?.description?.split(",")?.map(day => parseInt(day) - 1),
                        is_all: item?.description?.split(",")?.length === 5 ? true : false
                    }
                    if (_.filter(weekly, item => _.isEqual(item, obj?.day))?.length === 0) {
                        weekly.push(obj);
                        const index = _.indexOf(weekly, obj);
                        index !== 0 && setDayOpts((prev) => ({ ...prev, [index]: _.filter(dayOpts?.[0], (item) => (!_.pluck(_.pluck(weekly, "day"), "day_idx")?.includes(item?.day_idx) || item?.day_idx === obj?.day?.day_idx)) }))
                    }
                })

                // set holiday data
                let holiday = []
                const holiday_data = _.uniq(data?.holiday_data, "day_date");
                holiday_data?.forEach((item) => {
                    const obj = {
                        date: new Date(item?.day_date),
                        title: item?.description
                    }
                    if (_.filter(holiday, item => _.isEqual(new Date(item?.date), new Date(obj?.date)))?.length === 0) {
                        holiday.push(obj);
                    }
                })

                // set optional holiday data
                let optional = [];
                const optional_holiday_data = _.uniq(data?.optional_holiday, "day_date");
                optional_holiday_data?.forEach((item) => {
                    const obj = {
                        date: new Date(item?.day_date),
                        title: item?.description
                    }
                    if (_.filter(optional, item => _.isEqual(new Date(item?.date), new Date(obj?.date)))?.length === 0) {
                        optional.push(obj);
                    }
                })

                holiday?.sort((a, b) => new Date(a?.date) - new Date(b?.date));
                optional?.sort((a, b) => new Date(a?.date) - new Date(b?.date));

                setGenerateCalendarData((prev) => ({
                    ...prev,
                    configuration_data: { configuration_id: config?.configuration_id, configuration_name: config?.configuration_name },
                    display_name: config?.configuration_name,
                    weekly_off: { ...prev?.weekly_off, count: weekly_off_data?.length || 1, data: weekly },
                    holiday: { ...prev?.holiday, count: holiday_data?.length || 1, data: holiday },
                    optional_holiday: { ...prev?.optional_holiday, count: optional_holiday_data?.length || 1, data: optional },
                    shift_start: timeStringToDate(data?.shift_data?.[0]?.shift_start_time),
                    shift_end: timeStringToDate(data?.shift_data?.[0]?.shift_end_time),
                }));
                setLoader((prev) => ({ ...prev, fields: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, fields: false }));
        }
    }

    const handleSaveConfiguration = async () => {
        try {
            if (!generateCalendarData?.display_name) {
                showInfo("Info", "Please enter the config name");
                return;
            } else if (!generateCalendarData?.shift_start) {
                showInfo("Info", "Please select the shift start time");
                return;
            } else if (!generateCalendarData?.shift_end) {
                showInfo("Info", "Please select the shift end time");
                return;
            } else if (generateCalendarData?.shift_start >= generateCalendarData?.shift_end) {
                showInfo("Info", "Shift end cannot be less than shift start");
                return;
            } else if (_.isEmpty(generateCalendarData?.weekly_off?.data) && _.isEmpty(generateCalendarData?.holiday?.data) && _.isEmpty(generateCalendarData?.optional_holiday?.data)) {
                showInfo("Info", "No day type data added to save");
                return;
            }

            // all fields validations
            if (!_.isEmpty(generateCalendarData?.weekly_off?.data)) {
                let error = "";
                generateCalendarData?.weekly_off?.data?.forEach((item) => {
                    if (!_.isEmpty(item?.day) && !item?.is_all && _.isEmpty(item?.selected_each_day)) {
                        error = "Please fill all the weekly off data";
                        return;
                    }
                })
                if (error) {
                    showInfo("Info", error);
                    return;
                }
            }
            if (!_.isEmpty(generateCalendarData?.holiday?.data) || !_.isEmpty(generateCalendarData?.optional_holiday?.data)) {
                let error = "";
                const allData = generateCalendarData?.holiday?.data?.concat(generateCalendarData?.optional_holiday?.data)
                allData?.forEach((item) => {
                    if ((item?.date && !item?.title) || (!item?.date && item?.title)) {
                        error = "Please fill all the holiday/optional holiday fields";
                        return;
                    }
                })
                if (error) {
                    showInfo("Info", error);
                    return;
                }
            }

            setLoader((prev) => ({ ...prev, btn: true }));
            let tvpArray = [];
            generateCalendarData?.weekly_off?.data?.forEach((item) => {
                const datesArray = getDates(item?.day, item?.is_all ? [0, 1, 2, 3, 4] : item?.selected_each_day);
                tvpArray = tvpArray?.concat(datesArray.map(date => {
                    return {
                        day_calendar_config_mapping_id: 0,
                        day_type_id: generateCalendarData?.weekly_off?.day_type_id,
                        day_date: dateConvert(date, "iso-string")?.split("T")?.[0],
                        description: item?.is_all ? "1,2,3,4,5" : item?.selected_each_day?.map(item => item + 1)?.toString(),
                        day_name: _.findWhere(dayOpts?.[0], { day_idx: new Date(date)?.getDay() })?.weekday || "",
                    }
                }));
            })

            generateCalendarData?.holiday?.data?.forEach((item) => {
                if (item?.date) {
                    tvpArray?.push({
                        day_calendar_config_mapping_id: 0,
                        day_type_id: generateCalendarData?.holiday.day_type_id,
                        day_date: dateConvert(item?.date, "iso-string")?.split("T")?.[0],
                        description: item?.title,
                        day_name: _.findWhere(dayOpts?.[0], { day_idx: new Date(item?.date)?.getDay() })?.weekday
                    });
                }
            })

            generateCalendarData?.optional_holiday?.data?.forEach((item) => {
                if (item?.date) {
                    tvpArray?.push({
                        day_calendar_config_mapping_id: 0,
                        day_type_id: generateCalendarData?.optional_holiday?.day_type_id,
                        day_date: dateConvert(item?.date, "iso-string")?.split("T")?.[0],
                        description: item?.title,
                        day_name: item?.title
                    });
                }
            })

            const payload = {
                configuration_id: !_.isEmpty(generateCalendarData?.configuration_data) ? generateCalendarData?.configuration_data?.configuration_id : 0,
                configuration_name: generateCalendarData?.display_name || "",
                shift_start_time: dateConvert(generateCalendarData?.shift_start, "iso-string"),
                shift_end_time: dateConvert(generateCalendarData?.shift_end, "iso-string"),
                tvp_calendar_config: tvpArray
            }

            const res = await services.getInvokeRemote("POST", Urls("UPSERTDAYCALENDARCONFIG"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                setLoader((prev) => ({ ...prev, list: true, btn: false }));
                setCallAutopop(!callAutopop);
                handleReset();
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const upsertGenerateHolidayCalender = async () => {
        if (!publishData?.config?.configuration_id) {
            showInfo("info", "please select config")
            return;
        } else if (!publishData?.year) {
            showInfo("info", "please select year")
            return;
        } else if (!publishData?.unit?.group_id) {
            showInfo("info", "please select unit")
            return;
        }
        setLoader((prev) => ({ ...prev, publish_btn: true }));
        const payload = {
            year: publishData?.year,
            group_id: publishData?.unit?.group_id || 0,
            configuration_id: publishData?.config?.configuration_id || 0,
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('UPSERTGENERATEHOLIDAYCALEDAR'), payload)
            if (res.body.data) {
                showSuccess("success", res?.body?.message);
                await getHolidayCalender(publishData?.year, publishData?.unit);
                setGenerateCalendarData((prev) => ({ ...prev, configuration_data: {}, shift_start: "", shift_end: "" }));
                handleReset();
                setLoader((prev) => ({ ...prev, publish_btn: false }));
            }
        } catch (error) {
            console.error('Error :', error);
            setLoader((prev) => ({ ...prev, publish_btn: false }));
        }
    };

    const handleDelete = (key, index) => {
        let dataArray = [...generateCalendarData?.[key]?.data];
        dataArray?.splice(index, 1);
        setGenerateCalendarData((prev) => ({ ...prev, [key]: { ...prev?.[key], data: dataArray, count: prev?.[key]?.count > 1 ? prev?.[key]?.count - 1 : 1 } }));
    }

    const handleDeleteConfiguration = async (showConfir, config) => {
        try {
            if (showConfir) {
                setShowConfirmation((prev) => ({ ...prev, visible: true, config: config }));
                return;
            } else {
                const payload = {
                    configuration_id: config?.configuration_id
                }
                const res = await services.getInvokeRemote("POST", Urls("DELETEDAYCALENDARCONFIG"), payload);
                if (res) {
                    showSuccess("success", res?.body?.message);
                    setCallAutopop(!callAutopop);
                    handleReset();
                }
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    return useMemo(() => ({
        generateCalendarData, setGenerateCalendarData, handleDaySelection, dayOpts, handleReset, handleAddMore, handleDateSelection, handleSaveConfiguration, configList, getSavedConfiguration, loader, upsertGenerateHolidayCalender, publishData, setPublishData, handleDelete, handleDeleteConfiguration, showConfirmation, setShowConfirmation
    }), [generateCalendarData, setGenerateCalendarData, handleDaySelection, dayOpts, handleReset, handleAddMore, handleDateSelection, handleSaveConfiguration, configList, getSavedConfiguration, loader, upsertGenerateHolidayCalender, publishData, setPublishData, handleDelete, handleDeleteConfiguration, showConfirmation, setShowConfirmation])
}